import i18next from "i18next";
import { Rule } from "./ValidationTypes";

export const createNotEmptyRule = (message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("Must not be empty"),
		validateImmediately,
	},
	type: "not_empty",
	validate: async (value) => {
		if (Array.isArray(value)) return value.length > 0;
		return value?.toString().length > 0;
	},
});

export const createIsInRule = (list: any[], message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("Value must be in list"),
		validateImmediately,
	},
	type: "in",
	validate: async (value) => list.includes(value),
});

export const createIsNotInRule = (list: any[], message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("Value must be in list"),
		validateImmediately,
	},
	type: "not_in",
	validate: async (value) => !list.includes(value),
});
